import React, { useState } from 'react';
import { Button, Col, Form, Input, InputNumber, Modal, Row, message } from 'antd';
import { uploadImageWithPromise } from '../../utils/firebase/uploadImage';
import { fetchAPI } from '../../utils/use.api';
import Captcha from './Capcha';

export default function PopupCreate(
    {
        fetchNewData,
        setSelectedRowKey
    }: {
        fetchNewData: any,
        setSelectedRowKey: any
    }
) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [image, setImage] = useState<any>(null);

    async function handleOk() {
        form.validateFields()
            .then((values) => {
                uploadImageWithPromise(image, 'top30/')
                    .then((res) => {
                        console.log({
                            ...values,
                            ...res,
                        });
                        fetchAPI({
                            method: 'POST',
                            uri: '/posts/create',
                            Headers: {
                                'Content-Type': 'application/json',
                                'AccessToken': localStorage.getItem('token')
                            },
                            body: JSON.stringify({
                                ...values,
                                ...res,
                            }),
                        })
                            .then((res) => {
                                if (res?._id) {
                                    message.success('Thêm thành công');
                                    form.resetFields();
                                    setIsModalOpen(false);
                                    fetchNewData();
                                    setSelectedRowKey(null);
                                } else {
                                    message.error('Thêm thất bại');
                                }
                            })
                    })
            })
            .catch((errorInfo) => {
                console.log(errorInfo);
            });
    };

    const handleCancel = () => {
        setImage(null);
        form.resetFields();
        setIsModalOpen(false);
    }

    function hanldeUploadImage(e: any) {
        // check if file is image
        if (!e.target.files[0].type.includes('image')) {
            setImage(null);
            message.error('File không hợp lệ');
            return;
        }
        const file = e.target.files[0];
        setImage(file);
    }


    return (
        <>
            <Button type="primary" onClick={() => setIsModalOpen(true)}>
                Thêm mới
            </Button>
            <Modal
                title="Thêm mới"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Row gutter={[10, 10]} justify={'end'}>
                        <Col>
                            <Button key="back" onClick={handleCancel}>
                                Hủy
                            </Button>
                        </Col>
                        <Col>
                            <Captcha title='Thêm mới' callBack={handleOk} />
                        </Col>
                    </Row>
                ]}
            >
                <Form
                    form={form}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                >
                    <Form.Item
                        name="name"
                        label="Tên"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập tên',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="yearofbirth"
                        label="Năm sinh"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng năm sinh',
                            },
                        ]}
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="hometown"
                        label="Quê quán"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập quê quán',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="reach"
                        label="Lượt Reach"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập lượt reach',
                            },
                        ]}
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="engagement"
                        label="Engagement"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập engagement',
                            },
                        ]}
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        name="image_url"
                        label="Hình ảnh"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng upload hình ảnh',
                            },
                        ]}
                    >
                        <input type='file' accept='image/*' onChange={hanldeUploadImage} />
                    </Form.Item>
                    <Form.Item
                        name="video_url"
                        label="YT Video ID"
                        rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập Youtube Video ID',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
